import { GOOGLE_STREETVIEW_DEFAULT_CONFIG } from '../../../../app-kit/components/PcaMap/config';
import { useContext } from 'react';
import { PcaMapContext } from '../../../contexts/PcaMapContext/PcaMapContext';

export const useShowLocationInStreetView = () => {
  const { google, map, initialConfig } = useContext(PcaMapContext);
  const location = initialConfig?.center;

  return () => {
    if (!google || !map || !location) return;

    const { event, geometry, LatLng, StreetViewService, StreetViewSource, StreetViewStatus } =
      google.maps;
    const streetViewService = new StreetViewService();

    // load the images for the panorama...
    void streetViewService.getPanorama(
      { location, source: StreetViewSource.OUTDOOR },
      (data, status) => {
        // get the street view instance.
        const streetView = map.getStreetView();

        if (status !== StreetViewStatus.OK || !data?.location) return;

        streetView.setOptions(GOOGLE_STREETVIEW_DEFAULT_CONFIG);

        const setPov = () => {
          const streetViewPosition = streetView.getPosition();

          if (streetViewPosition) {
            // set the heading to look at the location,
            // instead of looking down the street.
            streetView.setPov({
              heading: geometry.spherical.computeHeading(streetViewPosition, new LatLng(location)),
              pitch: 0,
            });
          }
        };

        const panoSet = streetView.getPano() === data?.location?.pano;
        if (!panoSet) {
          event.addListenerOnce(streetView, 'position_changed', setPov);
          streetView.setPano(data.location.pano);
        } else {
          setPov();
        }
        streetView.setVisible(true);
      },
    );
  };
};
